import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { PublisherService } from '../../../core/services/publisher.service';
import { OktaService } from '../okta.service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  CacheConstant,
  ErrorResponseMessageType,
  OktaOperationSource,
  OktaOperationType,
  CacheDuration
} from '../../../core/constants/app.constant';
import { OktaOperation } from '../okta-operation';
import { HttpError } from '../../../shared/models/http-error';
import { Subscription } from 'rxjs';
import { AppUtilService } from '../../../core/utils/app-util.service';
import { OktaRoutes, AEMRoutes } from '../../../core/constants/routes.constant';
import { OktaConstant } from '../okta.constant';
import { BaseComponent } from '../../../app.base.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Footer } from '../../../../app/shared/models/footer';
//import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { AppCacheService } from '../../../core/services/cache/app-cache.service';
import { AppConfigService } from '../../../core/services/init/app-config.service';

@Component({
  selector: 'par-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent extends BaseComponent
  implements OnInit, OnDestroy {
  /***************Properties***************/
  websiteName: string = this.cache.get(CacheConstant.Env_Properties).theme;
  footerData : Footer;
  private forgotSubscription: Subscription;
  forgot: any = {
    errorMessage: '',
    username: ''
  };
  /***************Properties***************/

  /***************Constructor***************/
  constructor(private oktaService: OktaService, 
    private route: ActivatedRoute, 
    private router:Router,
    private cache:AppCacheService,
    deviceDetectorService: DeviceDetectorService,
    private appConfig: AppConfigService) {
    super(deviceDetectorService, cache, appConfig);
    this.footerData = super.getFooterData();
  }

  ngOnInit() {
    PublisherService.changeBannerHeader('Forgot Password');
    this.forgotSubscription = this.route.params.subscribe(params => {
      if (params.token) {
        this.setOktaCacheOperation({ token: params.token });
        this.router.navigate([OktaRoutes.VerifyToken]);
      }
    });
  }

  ngOnDestroy(): void {
    // this.forgotSubscription.unsubscribe();
  }
  /***************Constructor***************/

  /***************Component Methods***************/

  onCancelClick() {
    if (!this.isMobileDevice()) {
      AppUtilService.redirectToHome();
    } else {
      AppUtilService.redirectToHomeMobile();
    }
  }

  onHomeClick() {
    this.router.navigate(['/']);
  }

  onForgotPasswordSubmit() {
    if (!this.forgot.username) {
      this.forgot.errorMessage = OktaConstant.Messages.IdetificationRequiredMesssage;
      return;
    }

    this.forgot.errorMessage = '';

    this.oktaService
      .sendResetPasswordEmail(this.forgot.username)
      .subscribe((response: any) => {
        if (!(response.businessFault)) {
          this.setOktaCacheOperation({ emailAddress: response.emailAddress });
          this.router.navigate([OktaRoutes.EmailSent]);
        } else {
          this.forgot.errorMessage = AppUtilService.resolveErrorResponse(
            response as HttpError
          ).messageText;
        }
      });
  }

  /***************Component Methods***************/

  /***************Private Methods***************/

  private setOktaCacheOperation(data: any) {
    const forgotOperation: OktaOperation = {
      type: OktaOperationType.ForgotPassword,
      source: OktaOperationSource.ForgotPassword,
      data: data
    };
    this.cache.set(
      CacheConstant.Okta_Operation,
      forgotOperation,
      CacheDuration.OneMinute
    );
  }

  /***************Private Methods***************/

  onHome() {
    this.router.navigate(['/']);
  }
}
